<template>
    <div>
        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    background-color="secondary"
                    closed
                    no-margin-top
                    title="Arcada superior"
                    type="box"
                >
                    <template
                        v-if="!data.readonly"
                        slot="trailing"
                    >
                        <rkm-button
                            @click="$refs.ModalProcedimentoSuperior.open()"
                            color="primary"
                            small
                            title="Adicionar procedimento"
                        >
                            <rkm-icon icon="plus" />
                        </rkm-button>
                    </template>

                    <ProcedimentoClinicoList
                        :data="{form: data.form, model: getArcadas().superior}"
                        :readonly="data.readonly"
                        @edit="$refs.ModalProcedimentoSuperior.open($event)"
                    />

                    <ProcedimentoClinicoModal
                        :data="{form: data.form, model: getArcadas().superior}"
                        ref="ModalProcedimentoSuperior"
                    />

                    <rkm-row class="mt-2">
                        <rkm-col cols="12">
                            <rkm-form-textarea
                                :disabled="data.readonly"
                                :validations="validations.observacao"
                                label="Observações"
                                rows="6"
                                v-model="getArcadas().superior.observacao"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="!data.readonly">
                        <rkm-col>
                            <rkm-button
                                :disabled="getArcadas().superior.procedimentosClinicos.length === 0"
                                @click="includeProcedimentosArcadaInferior"
                                block
                                color="primary"
                            >
                                Replicar procedimentos para a arcada inferior
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-1">
            <rkm-col cols="12">
                <rkm-area
                    background-color="secondary"
                    closed
                    title="Arcada inferior"
                    type="box"
                >
                    <template
                        v-if="!data.readonly"
                        slot="trailing"
                    >
                        <rkm-button
                            @click="$refs.ModalProcedimentoInferior.open()"
                            color="primary"
                            small
                            title="Adicionar procedimento"
                        >
                            <rkm-icon icon="plus" />
                        </rkm-button>
                    </template>

                    <ProcedimentoClinicoList
                        :data="{form: data.form, model: getArcadas().inferior}"
                        :readonly="data.readonly"
                        @edit="$refs.ModalProcedimentoInferior.open($event)"
                    />

                    <ProcedimentoClinicoModal
                        :data="{form: data.form, model: getArcadas().inferior}"
                        ref="ModalProcedimentoInferior"
                    />

                    <rkm-row class="mt-2">
                        <rkm-col cols="12">
                            <rkm-form-textarea
                                :disabled="data.readonly"
                                :validations="validations.observacao"
                                label="Observações"
                                rows="6"
                                v-model="getArcadas().inferior.observacao"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row class="mt-2" v-if="!data.readonly">
                        <rkm-col>
                            <rkm-button
                                :disabled="getArcadas().inferior.procedimentosClinicos.length === 0"
                                @click="includeProcedimentosArcadaSuperior"
                                block
                                color="primary"
                            >
                                Replicar procedimentos para a arcada superior
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Components.
import ProcedimentoClinicoList from '@/components/ambulatorio/acolhimento-saude-bucal/components/procedimento-clinico/List'
import ProcedimentoClinicoModal from '@/components/ambulatorio/acolhimento-saude-bucal/components/procedimento-clinico/Modal'

// Mixins.
import {object} from '@/mixins'

export default {
    components: {ProcedimentoClinicoList, ProcedimentoClinicoModal},
    computed: {
        validations() {
            return {
                observacao: {max: 5000},
            }
        },
    },
    methods: {
        includeProcedimentosArcadaInferior() {
            const onConfirm = async () => {
                this.getArcadas().superior.procedimentosClinicos.forEach(procedimento => {
                    const hasProcedimento = this.getArcadas().inferior.procedimentosClinicos.find(p => p.procedimento.id === procedimento.procedimento.id)

                    if (!hasProcedimento) {
                        this.getArcadas().inferior.procedimentosClinicos.push(this.clone(procedimento))
                    }
                })
            }

            this.showConfirmation('Deseja realmente replicar o(s) procedimento(s) para a arcada inferior?', onConfirm)
        },
        includeProcedimentosArcadaSuperior() {
            const onConfirm = async () => {
                this.getArcadas().inferior.procedimentosClinicos.forEach(procedimento => {
                    const hasProcedimento = this.getArcadas().superior.procedimentosClinicos.find(p => p.procedimento.id === procedimento.procedimento.id)

                    if (!hasProcedimento) {
                        this.getArcadas().superior.procedimentosClinicos.push(this.clone(procedimento))
                    }
                })
            }

            this.showConfirmation('Deseja realmente replicar o(s) procedimento(s) para a arcada superior?', onConfirm)
        },
        getArcadas() {
            return this.data.model.odontograma.arcadas
        },
    },
    mixins: [object],
    props: {
        data: {type: Object, required: true},
    },
}
</script>
